export const getAllLibraryQuestions = (state: any) => state.allLibraryQuestions;
export const getSelectedQuestion = (state: any) => state.selectedQuestion;
export const getQuestionHistory = (state: any) => state.questionHistory;
export const getAllTags = (state: any) => state.allTags;
export const getAllCategories = (state: any) => state.allCategories;
export const isFetching = (state: any) => state.isFetching;
